import { flatten, flattenDepth, groupBy, map } from "lodash";
import { toVisualThousands } from "../utils";
import { labelFont } from "../visualConfig";

/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-08-14 15:37:47
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */
const createGrid = (list = []) => {
  const len = list.length;
  const offsetLeft = 100;
  const _width = (1210 - offsetLeft) / len;
  // const width = 100 / len;
  const top = [50, '55%'];
  const bottom = ['55%', 50]

  const result = list.map(({ value: typeList }, index) => {
    const _index = index * 2;
    const left = `${index * _width + offsetLeft}px`;
    const width = `${_width}px`;
    return typeList.map((a, i) => {
      return {
        id: _index + i,
        top: top[i],
        bottom: bottom[i],
        left,
        width,
        boundaryGap: true,
        containLabel: true,
      }
    })
  });

  return flatten(result);
};

const createXAxis = (list = [], label) => {
  const position = ['bottom', 'top'];
  const result = list.map(({ name: typeName, value: typeList }, index) => {
    const _index = index * 2;

    return typeList.map((a, i) => {
      return {
        type: 'category',
        nameLocation: 'center',
        name: i === 0 ? typeName : '',
        nameTextStyle: {
          padding: [6, 0, 0, 0],
          fontSize: 16,
          fontWeight: 'bold',
          color: '#000'
        },
        gridIndex: _index + i,
        data: label,
        position: position[i],
        axisLabel: { show: false },
        axisLine: { show: true, lineStyle: { color: '#ccc' } },
        axisTick: { show: false },
        minorTick: { show: false },
        splitLine: { show: false },
      }
    })
  });

  return flatten(result);
}

const calcMax = (dataList = []) => {
  const result = dataList.reduce(([a, b, c], { value }) => {
    const val = value[0];

    return [a + Number(val[0]), b + Number(val[1]), c + Number(val[2])]
  }, [0, 0, 0]);

  return Math.max(...result);
}

const groupByIndex = (list => {
  let i = 0;
  const res = groupBy(list, () => {
    return i++ % 2
  });

  return map(res, (val) => Math.max(...val));
})

const createYAxis = (list = []) => {
  const dataList = [];
  const yAxisLabel = ['社交媒体类', '新闻媒体类'];
  const result = list.map(({ value: typeList }, index) => {
    const _index = index * 2;

    return typeList.map((a, i) => {
      dataList.push(calcMax(a.value))

      return {
        name: yAxisLabel[i],
        nameLocation: 'center',
        nameRotate: 0,
        nameTextStyle: {
          fontSize: 16,
          fontWeight: 'bold',
          color: '#000'
        },
        gridIndex: _index + i,
        show: index === 0,
        max: () => maxData[i],
        inverse: i !== 0,
        type: 'value',
        axisLine: { show: false },
        axisLabel: { show: false },
        splitLine: { show: false },
      }
    })
  });

  const maxData = groupByIndex(dataList)

  return flatten(result);
}

const createSeries = (list = [], label = [], color = []) => {
  const position = ['top', 'bottom'];
  const result = list.map(({ value: typeList }, index) => {
    const _index = index * 2;

    return typeList.map((favor, i) => {

      const seriesItem = {
        stack: `${favor.name}${_index + i}`,
        xAxisIndex: _index + i,
        yAxisIndex: _index + i,
        type: 'bar',
      };

      return favor.value.map(({ name, value }, dataIndex)=> {
        const data = value[0].map((item, ii) => ({
          name: label[ii],
          value: item,
          itemStyle: {
            color: color[ii][dataIndex] || '#ccc'
          }
        }));

        return {
          ...seriesItem,
          name,
          data,
          label : {
            show: true,
            position: position[i],
            formatter: (ele) => toVisualThousands(ele.value),
            ...labelFont,
          }
        }
      }).reverse();
    })
  });

  return flattenDepth(result, 3);
}

export default ({ label = [], list, color = [] }) => {
  return {
    title: {},
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },
    grid: createGrid(list),
    xAxis: createXAxis(list, label),
    yAxis: createYAxis(list),
    series: createSeries(list, label, color),
  }
}


// WEBPACK FOOTER //
// src/routes/visualChart/P8/chart.js